export const initHeroStats = () => {
  const statNumbers = document.querySelector(
    '.secondary-hero .et_pb_code_inner .investment-success',
  );

  const heroStats = document.querySelector('.secondary-hero .et_pb_code_inner');

  if (statNumbers && heroStats) {
    heroStats.style.gridTemplateColumns = '50% 50%';
  }
};
